module.exports = __webpack_public_path__ + "media/images/sp/costumes/mv_irouchikake-3be37b517fd79bf79d28eea2fd8ee9c3.jpg";